import { Skeleton, Wrap, WrapItem } from "@chakra-ui/react";
import resolveIssueType from "features/Issues/Resolutions/resolveIssueType";
import { IssueDetail, IssueSummary } from "models/issue";
import { useMemo } from "react";
import { ActionV2 } from "features/Resources/Shared/models";
import IssueModalTag, { ActionIssueModalTag } from "../IssueModal";

function IssueModalTagSkeleton() {
  return (
    <Skeleton height="20px" width="80px" />
  );
}

export function ListIssues({ issues = [] }: { issues?: IssueSummary[] }) {
  const issueByLength = useMemo(() => (issues || []).sort((a, b) => (resolveIssueType(b)?.length || 0) - (resolveIssueType(a)?.length || 0)), [issues]);
  if (!issues?.length) return null;
  return (
    <Wrap>
      {issueByLength.map((issue: IssueSummary) => (
        <WrapItem key={issue.id} mt="3px">
          <IssueModalTag issue={issue} />
        </WrapItem>
      ))}
    </Wrap>
  );
}

export function ListActionIssues({ issues = [], action }: { issues?: IssueSummary[], action: ActionV2 }) {
  const issueByLength = useMemo(() => (issues || []).sort((a, b) => (resolveIssueType(b)?.length || 0) - (resolveIssueType(a)?.length || 0)), [issues]);
  if (!issues?.length) return null;
  return (
    <Wrap>
      {issueByLength.map((issue: IssueDetail) => (
        <WrapItem key={issue.id}>
          {action ? (
            <ActionIssueModalTag issue={issue} action={action} />
          ) : (
            <IssueModalTagSkeleton />
          )}
        </WrapItem>
      ))}
    </Wrap>
  );
}
